import { login, init, logout } from '../slices';
import SessionManager from '../manager';
import { takeLatestRequestHandler } from '@madbox/react_redux_request_handling';

const handlers = {
  login: {
    ...login,
    method: (action) => SessionManager.loginRequest(action.payload),
    options: {
      errorTransformer(error) {
        return error.errors;
      },
    },
  },
  init: {
    ...init,
    method: (action) => SessionManager.initRequest(action.payload),
    options: {},
  },
  logout: {
    ...logout,
    method: () => SessionManager.logout(),
  },
};

export default function* saga() {
  yield takeLatestRequestHandler(handlers.login);
  yield takeLatestRequestHandler(handlers.init);
  yield takeLatestRequestHandler(handlers.logout);
}
